import { render, staticRenderFns } from "./ProjectParticipantsTab.vue?vue&type=template&id=7fe7e371&scoped=true"
import script from "./ProjectParticipantsTab.vue?vue&type=script&lang=js"
export * from "./ProjectParticipantsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe7e371",
  null
  
)

export default component.exports